import { render, staticRenderFns } from "./taohnpf.vue?vue&type=template&id=32bc9d17&scoped=true&"
import script from "./taohnpf.vue?vue&type=script&lang=js&"
export * from "./taohnpf.vue?vue&type=script&lang=js&"
import style0 from "./taohnpf.vue?vue&type=style&index=0&id=32bc9d17&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bc9d17",
  null
  
)

export default component.exports